var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFillFormActiveIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg",
    fill: "#de1186",
    stroke: "#de1186",
    width: 200,
    height: 200,
    viewBox: "144 144 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "IconSvg_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "IconSvg_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#CCCCCC",
    strokeWidth: 0
  }, /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m523.1 583.3h-289.91v-390.45h289.91v134.09h10.078v-144.16h-310.06v31.406h-24.641v406.02h271.65v-26.84h63.047v-154.73h-10.078zm-63.047 26.836h-251.5v-385.87h14.566v369.11h236.93z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m263.65 214.2h65.812v10.078h-65.812z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m263.65 270.69h230.39v10.078h-230.39z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m263.65 321.91h230.39v10.078h-230.39z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m263.65 373.96h195.96v10.078h-195.96z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m263.65 424.35h150.7v10.078h-150.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m263.65 478.93h116.89v10.078h-116.89z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m263.65 533.13h160.22v10.078h-160.22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m407.83 463.25-11.566 50.047 49.961-11.332-0.097656-0.41406 0.80078 0.80078 172.22-172.23-39.699-39.695-172.22 172.22zm1.8633 36.664 6.5391-28.258 21.824 21.824zm157.1-131.68-88.301 88.309-25.453-25.457 88.297-88.297zm-18.328-32.578 3.2031-3.1992 25.449 25.453-3.1953 3.1953zm56.434-5.5273-20.66 20.66-25.449-25.453 20.656-20.656zm-158.98 108.08 25.453 25.457-24.445 24.445-25.453-25.457z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m494.46 214.2h-66.543v47.258l66.543-0.003906zm-10.074 37.18h-46.391v-27.105h46.391z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m447.02 538.17c0 14.355 11.68 26.031 26.031 26.031 14.355 0 26.031-11.68 26.031-26.031 0-14.355-11.68-26.031-26.031-26.031-14.352 0-26.031 11.68-26.031 26.031zm41.988 0c0 8.7969-7.1602 15.957-15.957 15.957s-15.957-7.1602-15.957-15.957 7.1602-15.957 15.957-15.957 15.957 7.1602 15.957 15.957z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m339 214.2h22.633v10.078h-22.633z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "IconSvg_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m523.1 583.3h-289.91v-390.45h289.91v134.09h10.078v-144.16h-310.06v31.406h-24.641v406.02h271.65v-26.84h63.047v-154.73h-10.078zm-63.047 26.836h-251.5v-385.87h14.566v369.11h236.93z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m263.65 214.2h65.812v10.078h-65.812z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m263.65 270.69h230.39v10.078h-230.39z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m263.65 321.91h230.39v10.078h-230.39z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m263.65 373.96h195.96v10.078h-195.96z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m263.65 424.35h150.7v10.078h-150.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m263.65 478.93h116.89v10.078h-116.89z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m263.65 533.13h160.22v10.078h-160.22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m407.83 463.25-11.566 50.047 49.961-11.332-0.097656-0.41406 0.80078 0.80078 172.22-172.23-39.699-39.695-172.22 172.22zm1.8633 36.664 6.5391-28.258 21.824 21.824zm157.1-131.68-88.301 88.309-25.453-25.457 88.297-88.297zm-18.328-32.578 3.2031-3.1992 25.449 25.453-3.1953 3.1953zm56.434-5.5273-20.66 20.66-25.449-25.453 20.656-20.656zm-158.98 108.08 25.453 25.457-24.445 24.445-25.453-25.457z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m494.46 214.2h-66.543v47.258l66.543-0.003906zm-10.074 37.18h-46.391v-27.105h46.391z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m447.02 538.17c0 14.355 11.68 26.031 26.031 26.031 14.355 0 26.031-11.68 26.031-26.031 0-14.355-11.68-26.031-26.031-26.031-14.352 0-26.031 11.68-26.031 26.031zm41.988 0c0 8.7969-7.1602 15.957-15.957 15.957s-15.957-7.1602-15.957-15.957 7.1602-15.957 15.957-15.957 15.957 7.1602 15.957 15.957z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m339 214.2h22.633v10.078h-22.633z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFillFormActiveIcon);
export default __webpack_public_path__ + "static/media/fill_form_active_icon.9e14f74b397f3308d1f5b2d9dfde4ec1.svg";
export { ForwardRef as ReactComponent };